import { lazy } from 'react';

const AccessRequestTable = lazy(() => import('./AccessRequestTable'));
const SecurityAccessRequestTable = lazy(() => import('./SecurityAccessRequestTable'));
const SecurityKeyRequestTable = lazy(() => import('./SecurityKeyRequestTable'));
const ServiceRequestTable = lazy(() => import('./ServiceRequestTable'));
const KeyRequestTable = lazy(() => import('./KeyRequestTable'));
const NotificationCentre = lazy(() => import('../components/Notification/NotificationCentre'));
const DocumentCentre = lazy(() => import('../components/DocumentCentre/DocumentCentre'));
const IncidentRequestTable = lazy(() => import('./IncidentRequestTable'));
const ChangeRequestTable = lazy(() => import('./ChangeRequestTable'));
const UserDashboard = lazy(() => import('./UserDashboard'));
const MaintenanceDashboard = lazy(() => import('../components/CalendarWidget'));
const AuthorisedAccessList = lazy(() => import('../components/AuthorisedAccessList'));
const Contacts = lazy(() => import('../components/ContactsPage'));

export const ADMIN_TABS = [
  {
    label: 'Home',
    component: UserDashboard,
    pathname: '/home',
    icon: 9,
    type: 'dashboard',
  },
  {
    label: 'Access Requests',
    component: AccessRequestTable,
    pathname: '/a-access-requests',
    icon: 0,
    type: 'access',
  },
  {
    label: 'Security',
    component: SecurityAccessRequestTable,
    pathname: '/a-security-access-requests',
    icon: 1,
    type: 'security',
  },
  {
    label: 'Service Requests',
    component: ServiceRequestTable,
    pathname: '/a-service-requests',
    icon: 2,
    type: 'service',
  },
  {
    label: 'Change Requests',
    component: ChangeRequestTable,
    pathname: '/a-change-requests',
    icon: 3,
    type: 'change',
  },
  {
    label: 'Incidents',
    component: IncidentRequestTable,
    pathname: '/a-incident-requests',
    icon: 4,
    type: 'incidents',
  },
  {
    label: 'Data Centre Keys',
    component: KeyRequestTable,
    pathname: '/a-key-requests',
    icon: 5,
    type: 'keys',
  },
  {
    label: 'Maintenance',
    component: MaintenanceDashboard,
    pathname: '/a-maintenance',
    icon: 10,
    type: 'maintenance',
  },
  {
    label: 'Communications',
    component: NotificationCentre,
    pathname: '/a-notifications',
    icon: 6,
    type: 'notifications',
  },
  {
    label: 'Document Centre',
    component: DocumentCentre,
    pathname: '/a-documents-centre',
    icon: 7,
    type: 'documents',
  },
  {
    label: 'Contact Management',
    tooltip: 'Contact Management',
    component: Contacts,
    pathname: '/a-contacts',
    icon: 11,
    type: 'contact',
  },
  {
    label: 'Authorised Access List',
    tooltip: 'AAL Management',
    component: AuthorisedAccessList,
    pathname: '/a-authorised-access-list',
    icon: 12,
    type: 'aal',
  },
];

export const OPERATIONS_TABS = [
  {
    label: 'Access Requests',
    component: AccessRequestTable,
    pathname: '/o-access-requests',
    icon: 0,
    type: 'access',
  },
  {
    label: 'Security',
    component: SecurityAccessRequestTable,
    icon: 1,
    pathname: '/o-security-access-requests',
    type: 'security',
  },
  {
    label: 'Service Requests',
    component: ServiceRequestTable,
    pathname: '/o-service-requests',
    icon: 2,
    type: 'service',
  },
  {
    label: 'Change Requests',
    component: ChangeRequestTable,
    pathname: '/o-change-requests',
    icon: 3,
    type: 'change',
  },
  {
    label: 'Incidents',
    component: IncidentRequestTable,
    pathname: '/o-incident-requests',
    icon: 4,
    type: 'incidents',
  },
  {
    label: 'Data Centre Keys',
    component: KeyRequestTable,
    pathname: '/o-key-requests',
    icon: 5,
    type: 'keys',
  },
  {
    label: 'Communications',
    component: NotificationCentre,
    pathname: '/o-notifications',
    icon: 6,
    type: 'notifications',
  },
  {
    label: 'Contact Management',
    tooltip: 'Contact Management',
    component: Contacts,
    pathname: '/o-contacts',
    icon: 11,
    type: 'contact',
  },
  {
    label: 'Authorised Access List Management',
    tooltip: 'AAL Management',
    component: AuthorisedAccessList,
    pathname: '/o-authorised-access-list',
    icon: 12,
    type: 'aal',
  },
];

export const SECURITY_TABS = [
  {
    label: 'Access Requests',
    component: AccessRequestTable,
    pathname: '/s-access-requests',
    icon: 0,
    type: 'access',
  },
  {
    label: 'Security',
    component: SecurityAccessRequestTable,
    icon: 1,
    pathname: '/s-security-access-requests',
    type: 'security',
  },
  {
    label: 'Data Centre Keys',
    component: KeyRequestTable,
    pathname: '/s-key-requests',
    icon: 5,
    type: 'keys',
  },
  {
    label: 'Contact Management',
    tooltip: 'Contact Management',
    component: Contacts,
    pathname: '/s-contacts',
    icon: 11,
    type: 'contact',
  },
  {
    label: 'Authorised Access List Management',
    tooltip: 'AAL Management',
    component: AuthorisedAccessList,
    pathname: '/s-authorised-access-list',
    icon: 12,
    type: 'aal',
  },
];

export const VALID_SUBPATHS = [
  ...ADMIN_TABS.map((tab) => tab.pathname.slice(1)),
  ...OPERATIONS_TABS.map((tab) => tab.pathname.slice(1)),
  ...SECURITY_TABS.map((tab) => tab.pathname.slice(1)),
];
